import { gql } from '@apollo/client/core';
import client from '../util/graphql';
import { getGalaxionBrand } from '../util/app.util';

const QUERIES = {
  GET_WEB_MESSENGER_CONFIG: gql`
    query GetWebMessengerConfig {
      webMessengerConfig {
        config {
          TYPE
          PAGES {
            PAGE
          }
          SCRIPTS {
            SCRIPT
          }
          SCHEDULES {
            TYPE
            START_TIME
            END_TIME
          }
        }
        holidays {
          DATE
        }
        cache
      }
    }
  `,
};

const getWebMessengerConfig = async () => {
  try {
    const { data } = await client.query({
      query: QUERIES.GET_WEB_MESSENGER_CONFIG,
      context: {
        headers: {
          'Galaxion-Brand': getGalaxionBrand(),
        },
      },
    });
    return data;
  } catch (err) {
    console.error(err.message);
  }
};

export default getWebMessengerConfig;
